<div class="layout-cards">
  @for (card of data().cards; track card.id) {
    <ng-template [paiInsertDynamicCard]="card" />
  }
</div>
